import React, {useState, useEffect} from "react";
import {getUser, mobileCheck} from "../utils/Common";
import "./Notifications.css";
import MasterNotifications from "./MasterNotifications";
import PowerNotifications from "./PowerNotifications";
import MotionNotifications from "./MotionNotifications";
import { getSharedCaps, patchUser } from "../utils/bedrockAPI";

export default function Notifications(props) {
    const [notifyTab, setNotifyTab] = useState("power");
    const [sharedCaps, setSharedCaps] = useState(null);
    const [demoOnly, setDemoOnly] = useState(true);
    const [appNotifications, setAppNotifications] = useState(false);

    useEffect(() => {
        let isMounted=true;

        async function fetchSharedCaps(userId) {
            const tempSharedCaps = await getSharedCaps(userId);
            if(isMounted)
                setSharedCaps(tempSharedCaps);
        }
        fetchSharedCaps(getUser().userId);

        return () => { isMounted = false; };
    },[]);

    useEffect(() => {
        let t = props.match.params.tab
        if(t && ["power","motion"].includes(t)) {
            setNotifyTab(t);
        } else if(t==="nudge") {
            const u = getUser();
            const m = mobileCheck();
            if(u.settings.nudge) {
                if(m && u.settings.nudge.appNotifications && u.settings.nudge.appNotifications.fibonacci) {
                    let update = JSON.parse(JSON.stringify(u.settings));
                    update.nudge.appNotifications.fibonacci += 5;
                    patchUser(u.userId,{settings:update});
                } else if(!m && u.settings.nudge.desktopNotifications && u.settings.nudge.desktopNotifications.fibonacci) {
                    let update = JSON.parse(JSON.stringify(u.settings));
                    update.nudge.desktopNotifications.fibonacci += 5;
                    patchUser(u.userId,{settings:update});
                }
            }
        }
    },[props.match.params.tab]);

    useEffect(() => {
        if(sharedCaps) {
            let tempDemoOnly = true;
            if(getUser().role==='ADMIN') {
                tempDemoOnly = false;
            } else {
                for(var i=0; i<sharedCaps.length; i++) {
                    if(['VIEWER','OWNER'].includes(sharedCaps[i].accessType)) {
                        tempDemoOnly = false;
                        break;
                    }
                }
            }
            setDemoOnly(tempDemoOnly);
        }
    },[sharedCaps]);

    function selectTab(tab) {
        setNotifyTab(tab);
        props.history.push(`/account/notifications/${tab}`);
    }

    return (
        <div className="notifications-page">
            <header className="notifications-header">
                <h1>Notification Settings</h1>
                <p className="notifications-subtitle">
                    Control how Bedrock reaches you. Master settings below override individual power and motion preferences.
                </p>
            </header>

            <MasterNotifications setAppNotificationsParent={setAppNotifications} />

            <div className="notifications-tabs">
                <button
                    type="button"
                    className={`notifications-tab ${notifyTab === "power" ? "active" : ""}`}
                    onClick={() => selectTab("power")}
                >
                    Power Notifications
                </button>
                {!demoOnly && (
                    <button
                        type="button"
                        className={`notifications-tab ${notifyTab === "motion" ? "active" : ""}`}
                        onClick={() => selectTab("motion")}
                    >
                        Motion Notifications
                    </button>
                )}
            </div>
            <div className="notifications-tab-content">
                {notifyTab === "power" && (
                    <PowerNotifications appNotificationsFromMaster={appNotifications} />
                )}
                {notifyTab === "motion" && (
                    <MotionNotifications />
                )}
            </div>
        </div>
    )
}
